import { HttpClientModule, HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UtilsModule } from '@gravity-angular/utils';
import { BaseModule } from '@gravity-angular/base';
import { MarkdownModule, MARKED_OPTIONS } from 'ngx-markdown';

import { PortalModule } from '@angular/cdk/portal';
import { MatDialogModule } from '@angular/material/dialog';
import { AppRoutingModule } from './app-routing.module';
import { AuthConfigModule } from './auth/oidc-config/auth-config.module';
import { AmplifyService } from './aws/amplify.service';
import { CarouselSliderComponent } from './landing/carousel-slider/carousel-slider.component';
import { LandingComponent } from './landing/landing.component';
import { DateConversionsService, SharedModule } from './shared/shared.module';
import { ProcessingDialogComponent } from './user-management/processing-dialog/processing-dialog.component';

import { NewpiperdiverComponent } from './newpiperdiver/newpiperdiver.component';
import { SupersetComponent } from './superset/superset.component';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';

import { NgIdleModule } from '@ng-idle/core';
import { AuthorizeComponent } from './authorize/authorize.component';
import { IdleLogoutDialogComponent } from './idle-logout-dialog/idle-logout-dialog.component';
import { LoginComponent } from './login/login.component';
import { ManagedServicesModule } from './managed-services/managed-services.module';
import { ConfirmationDialogComponent } from './shared/confirmation-dialog/confirmation-dialog.component';
import { SqlGeneratorModule } from './sql-generator/sql-generator.module';
import { MatIconModule } from '@angular/material/icon';
@NgModule({
  declarations: [],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BaseModule,
    NgIdleModule.forRoot(),
    PortalModule,
    UtilsModule,
    HttpClientModule,
    MatSliderModule,
    MatTableModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatInputModule,
    MatDialogModule,
    MatIconModule,
    AuthConfigModule,
    SharedModule,
    ManagedServicesModule,
    SqlGeneratorModule,
    LandingComponent,
    CarouselSliderComponent,
    ProcessingDialogComponent,
    SupersetComponent,
    IdleLogoutDialogComponent,
    NewpiperdiverComponent,
    ConfirmationDialogComponent,
    AuthorizeComponent,
    LoginComponent,
    MarkdownModule.forRoot({
      loader: HttpClient,
      markedOptions: {
        provide: MARKED_OPTIONS,
        useValue: {
          gfm: true,
          breaks: true,
          pedantic: false
        }
      }
    })
  ],
  exports: [],
  providers: [DateConversionsService, AmplifyService]
})
export class AppModule {}
